import { fetchAPI } from './apiClient';

export interface GanadorInfo {
  num1: string;
  num2: string | null;
  num3: string | null;
  tipo_premio: string | null;
  tipo_monazos: string | null;
  paga_reventado: boolean | null;
}

export interface PremioCombo {
  combinacion: string;
  monto: string;
}

export interface TicketPremiadoItem {
  ticket_number: string;
  vendedor_id: string | null;
  monto_apostado: string;
  premio_pagado: string;
}

export interface ReporteSorteo {
  sorteo_id: string;
  sorteo_nombre: string;
  tipo_id: string;
  estado: string;
  total_vendido: string;
  total_premios: string;
  comision_porcentaje: string | null;
  comision_potencial: string;
  comision_ganada: string;
  comision_no_ganada: string;
  comision_no_ganada_motivo: string;
  resultado_informativo: string;
  usa_restringidos: boolean;
  total_vendido_restringidos: string | null;
  total_vendido_no_restringidos: string | null;
  detalle_restringidos: DetalleRestringido[] | null;
  riesgo_pct: string | null;
  ganadores: GanadorInfo[];
  premios_por_combo: PremioCombo[];
  total_premios_pagados: string;
  tickets_premiados: TicketPremiadoItem[];
}

export interface DetalleRestringido {
  numero: string;
  monto_vendido: string;
  monto_permitido: string;
  riesgo_pct: string;
  comision_ganada: string;
  comision_perdida: string;
}

export interface ReporteTotales {
  total_vendido: string;
  total_premios: string;
  total_comision_ganada: string;
  total_comision_no_ganada: string;
  total_pagas: string;
}

export interface ReporteResponse {
  fecha: string;
  sorteos: ReporteSorteo[];
  totales: ReporteTotales;
}

export interface LocalOption {
  id: string;
  nombre: string;
}

export interface SorteoDelDia {
  id: string;
  nombre: string;
  tipo_id: string;
  estado: string;
  hora_cierre: string | null;
}

export async function fetchReportePorSorteo(
  fecha: string,
  sorteoId?: string,
  localId?: string,
  fechaFin?: string,
  incluirDetalle: boolean = true,
): Promise<ReporteResponse> {
  const params = new URLSearchParams();
  if (fechaFin) {
    params.set('fecha_inicio', fecha);
    params.set('fecha_fin', fechaFin);
  } else {
    params.set('fecha', fecha);
  }
  if (sorteoId) params.append('sorteo_id', sorteoId);
  if (localId) params.append('local_id', localId);
  params.set('incluir_detalle', String(incluirDetalle));
  return fetchAPI<ReporteResponse>(`/reportes/por-sorteo?${params.toString()}`);
}

export async function fetchLocalesReporte(): Promise<LocalOption[]> {
  return fetchAPI<LocalOption[]>('/reportes/locales');
}

export async function fetchSorteosDelDia(fecha: string, fechaFin?: string): Promise<SorteoDelDia[]> {
  const params = new URLSearchParams();
  if (fechaFin) {
    params.set('fecha_inicio', fecha);
    params.set('fecha_fin', fechaFin);
  } else {
    params.set('fecha', fecha);
  }
  return fetchAPI<SorteoDelDia[]>(`/reportes/sorteos-del-dia?${params.toString()}`);
}

export async function fetchPremiosPagados(
  fecha: string,
  sorteoId?: string,
  localId?: string,
): Promise<any[]> {
  const params = new URLSearchParams({ fecha });
  if (sorteoId) params.append('sorteo_id', sorteoId);
  if (localId) params.append('local_id', localId);
  return fetchAPI<any[]>(`/reportes/premios?${params.toString()}`);
}
